import { useEffect } from 'react'

const bodyStyle = document.body.style

const useBlockBodyScroll = (isOn: boolean, scrollTop = true) => {
  useEffect(() => {
    if (isOn) {
      if (scrollTop) window.scrollTo({ top: 0, behavior: 'smooth' })
      bodyStyle.overflowY = 'hidden'
      bodyStyle.position = 'fixed'
    } else {
      bodyStyle.overflowY = 'scroll'
      bodyStyle.position = 'static'
    }

    return () => {
      bodyStyle.overflowY = 'scroll'
      bodyStyle.position = 'static'
    }
  }, [isOn, scrollTop])
}

export { useBlockBodyScroll }
